import script from "./AppLayoutSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayoutSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayoutSidebar.vue?vue&type=style&index=0&id=2f3b86ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f3b86ac"]])

export default __exports__